import {
  makeCurrencyFormatter,
  percentageFormatter,
  percentageNoSymbolFormatter,
  scaledPercentageFormatter,
  numberFormatter,
} from "helpers/formatters/numbers"
import { VALUE_FORMATS } from "./constants"
import { NIL_DISPLAY } from "./nil-display"

function withNullHandling(formatter) {
  return (value) => (value == null ? NIL_DISPLAY : formatter(value))
}

/**
 * Gets a formatter for a given VALUE_FORMATS type.
 *
 * @param {string} format - VALUE_FORMATS constant
 * @param {Object} options - Formatter options
 * @param {boolean} options.includeUnits - If true, includes units (%). Default: true for tooltips. CURRENCY always includes its "$" regardless of this flag.
 * @param {boolean} options.handleNull - If true, returns "-" for null/undefined. Default: false.
 * @returns {Function} Formatter function
 */
export function getFormatter(format, { includeUnits = true, handleNull = false } = {}) {
  let formatter

  switch (format) {
    case VALUE_FORMATS.PERCENT:
      formatter = includeUnits ? percentageFormatter : percentageNoSymbolFormatter
      break
    case VALUE_FORMATS.PERCENT_100:
      formatter = includeUnits ? scaledPercentageFormatter : numberFormatter
      break
    case VALUE_FORMATS.NUMBER:
      formatter = numberFormatter
      break
    case VALUE_FORMATS.CURRENCY:
      formatter = makeCurrencyFormatter(undefined, { displayCurrencySymbol: true })
      break
    case VALUE_FORMATS.STRING:
    default:
      formatter = String
  }

  return handleNull ? withNullHandling(formatter) : formatter
}
